const DelayTimelineOptions = {
  MONTH: "month",
  QUARTER: "quarter",
  YEAR: "year"
};

export default DelayTimelineOptions;
